export default (yearlyDonationUrl = "", monthlyDonationUrl = "", manualDonationUrl = "") => ({

    amount: null,
    yearlyDonationUrl: yearlyDonationUrl,
    monthlyDonationUrl: monthlyDonationUrl,
    manualDonationUrl: manualDonationUrl,
    subscriptionType: "monthly",
    subscriptionAmount: "5",

    init(){
        console.log('component donation form mounted...');
    },

    clickCtaButton() {
        this.openSubscriptionUrl()
    },
    openSubscriptionUrl() {
        switch(this.subscriptionType) {
            case 'yearly':
                window.open(this.yearlyDonationUrl + Math.round(this.subscriptionAmount.replace('.','')), "_blank").focus();
                break;
            case 'monthly':
                window.open(this.monthlyDonationUrl + Math.round(this.subscriptionAmount.replace('.','')), "_blank").focus();
                break;
            case 'manual':
                window.open(this.manualDonationUrl, "_blank").focus();
                break;
        }
    },
})